import React from 'react';
import "./style.css";
const OfflineBar = () => {
    return (
        <div className="offline-header">
            <div className="offline-description">
                <p>Unable to connect internet</p>
                <p>Check your internet connection</p>
            </div>
            <span className="material-icons">
                signal_wifi_off
            </span>
        </div>
    );
}

export default OfflineBar;